module.exports = __webpack_public_path__ + "img/slide1.f7da2d06.png";